<template>
    <div>
        <div class="search_container searchArea">
            <el-form :inline="true" :model='searchForm' ref="searchForm" @submit.native.prevent class="demo-form-inline search-form">
                <el-form-item label="学年学期" >
                    <el-select v-model="searchForm.semester" filterable placeholder="请选择" style="width: 100%">
                        <el-option :key="null" label="全部" :value="null"></el-option>
                        <el-option v-for="item in acadyearTermList" :key="item" :label="item" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="考试状态">
                    <el-select v-model="searchForm.state" filterable placeholder="请选择">
                        <el-option :key="null" label="全部" :value="-1"></el-option>
                        <el-option :key="0" label="阅卷中" :value="0"></el-option>
                        <el-option :key="2" label="已结束" :value="2"></el-option>
                    </el-select>
                </el-form-item>
               

                <el-form-item label="查找">
                    <el-input v-model="searchForm.searchText" placeholder="请输入考试名称关键字"  @keyup.enter.native='loadMyExamList'></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" size ="mini" icon="search" @click='loadMyExamList'>查询</el-button>
                </el-form-item>
                <el-form-item>

                </el-form-item>
            </el-form>
        </div>
         <!-- 教师参与阅卷/所属阅卷组长的考试卡片列表 -->
         <div class="dataDashBoard"  v-loading="loading">
            <el-card class="box-card" v-for="(item, index) in tableData" v-if="userInfo.role == 'teacher'">

                <div slot="header" class="clearfix" style="text-align: left;" v-if="item.examType !== '复核' && item.examType !== '存疑'">
                    <!-- <span class="tag" v-if="item.yc_t_total_count > 0" style="background-color: red">存疑</span> -->
                    <span class="tag" >{{getExamType(item.category)}}</span>
                    <span class="sub-text">{{item.semester}}</span>
                    <span class="bold-text">{{item.name}}(考试号：{{item.id}})</span>
         

                </div>
                <div v-else slot="header" class="clearfix" style="text-align: left;">
                    <span class="tag" style="background-color: red" v-if="item.t_total_count > 0 && item.t_total_count > item.t_yy_count">{{getExamType("复核")}}</span>
                    <span class="tag" style="background-color: red" v-if="item.yc_t_total_count > 0">{{getExamType("存疑")}}</span>
                    <span class="sub-text">{{item.semester}}</span>
                    <span class="bold-text">{{item.name}}(考试号：{{item.id}})</span>
                </div>

                <div class="text item" style="text-align: left;"  v-if="item.examType !== '复核' && item.examType !== '存疑'">
                    <el-row class="content-row">
                        <el-col :span="16">
                            <span class="col-span">
                                所属单位：{{item.school_name?item.school_name:'无'}}, 阅卷组长：{{item.nick_name}}({{item.user_name}})
                            </span>
                        </el-col>
                        <el-col :span="6">
                            <span class="col-span">
                                您已阅：{{item.zg_yy_teacher_count}}
                            </span>
                        </el-col>
                        <el-col :span="2">
                            <!-- <el-button type="primary" size ="medium" icon="search" @click='jumpCheck(item)'>查看页面</el-button> -->

                            <el-button type="primary" size ="medium" icon="search" v-if="item.state< 2" @click='jumpCheck(item)'>查看页面</el-button>
                            <el-tag type="primary" size ="medium" icon="search" v-else >已结束</el-tag>
                        </el-col>
                    </el-row>


                </div>


            </el-card>

            <pagination  :pageSize="searchForm.pageSize" :currentPage="searchForm.pageNo" :pageTotal="searchForm.totalCount" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pagination>
            </div>

    </div>
</template>
<script>

    import {mapActions, mapGetters, mapState} from 'vuex'
    import util from '@/common/util'
    import * as simpleApi from "request/simple";
    import XEUtils from "xe-utils";
    import Pagination from "@/components/pagination";
    import XLSX from "xlsx";
    import {getDomain} from "@/utils/mUtils";
    import * as mUtils from '@/utils/mUtils'

    export default {
        data() {
            return {
                isInCefClient: false, 
                userData: [], 
                myChangePass:{id: null}, 
                tableData: [], 
                loading: false,
                searchForm: { 
                    pageNo: 1, 
                    pageSize: 20, 
                    totalCount: 0, 
                    searchText: null, 
                    schoolId: null,
                    semester: null,
                    state: -1,
                },
                acadyearTermList: [],

            }
        },
        components: {
            Pagination
        },
        computed: {
            ...mapState({
                userInfo: state => state.user.userInfo,
            }),
        },
        created() {
        },
        mounted() {
            this.loadAcadyearTermList();
            if(this.userInfo.role == 'teacher'){
                this.loadMyExamList();
            }
        },
        methods: {
            loadMyExamList(){
                // debugger
                let status = XEUtils.toNumber(this.searchForm.state)
                if(status === -1 || !status) status = null
                // 加载参与阅卷的考试和为阅卷组长的考试
                this.loading = true;
                let myTeacherId = this.userInfo.id;
                let search = { 
                    searchText: mUtils.searchText(this.searchForm.searchText), 
                    semester: mUtils.searchText(this.searchForm.semester), 
                    status: status,  
                    licenceId: this.userInfo.licenceId,
                    teacherId: myTeacherId, 
                    rules: myTeacherId,
                    orderBy: 'e.id desc',
                    type: 'review'
                };
                let param = { controllerName: 'akExam', methodName: '/listByTeacher', pageNo: this.searchForm.pageNo, pageSize: this.searchForm.pageSize, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {

                    if (data.code == 0) {
                        let tableData = data.result;
                        for (let i=0; i<tableData.length; i++){
                            let d = tableData[i];
                            if(d.rules != null) {
                                let rules = JSON.parse(d.rules);
                                let hardClassIds = [], teachingClassIds = [];
                                if("hardClassList" in rules && rules.hardClassList != null){
                                    for(let j=0; j<rules.hardClassList.length; j++){
                                        let r = rules.hardClassList[j];
                                        if(r.teacherId == myTeacherId){
                                            let myFind = XEUtils.find(hardClassIds, item => { return item == r.hardClassId; });
                                            if(!myFind) hardClassIds.push(r.hardClassId);
                                        }
                                    }
                                }
                                d["hardClassIds"] = hardClassIds;
                                if("teachingClassList" in rules && rules.teachingClassList != null){
                                    for(let j=0; j<rules.teachingClassList.length; j++){
                                        let r = rules.teachingClassList[j];
                                        if(r.teachers != null && r.teachers.length > 0){
                                            let tchId = r.teachers[0].id;
                                            if(tchId == myTeacherId){
                                                let myFind = XEUtils.find(teachingClassIds, item => { return item == r.id; });
                                                if(!myFind) teachingClassIds.push(r.id);
                                            }
                                        }
                                    }
                                }
                                d["teachingClassIds"] = teachingClassIds;
                            }
                        }
                        console.log(tableData)
                        this.tableData = tableData;
                        this.searchForm.pageNo = data.pageNo;
                        this.searchForm.pageSize = data.pageSize;
                        this.searchForm.totalCount = data.totalCount;

                    }
                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;
                    console.log("error", error)
                });
            },
            handleCurrentChange(val){
                this.searchForm.pageNo = val;
                this.loadMyExamList()
            },
            // 每页显示多少条
            handleSizeChange(val){
                this.searchForm.pageSize = val;
                this.loadMyExamList()
            },
            getExamType(v){
                if(v == 0) return "期中";
                if(v == 1) return "期末";
                if(v == 2) return "补考";
                if(v == 3) return "测验";
                if(v == 4) return "其他";
                
                return v;
            },
            getExamTypeColor(v){
                if(v == 0) return "#BC8DEE";
                if(v == 1) return "#8693F3";
                if(v == 2) return "#89C3F8";
                if(v == 3) return "#BC8DEE";
                if(v == 4) return "#8693F3";
               
                return '#000';
            },
            loadAcadyearTermList(){
                this.acadyearTermList = [];
                let now = new Date();
                let year = parseInt(now.getFullYear());

                for(let i=(year-3); i<(year+2); i++){
                    this.acadyearTermList.unshift((i-1) + '-' + i + '第一学期');
                    this.acadyearTermList.unshift((i-1) + '-' + i + '第二学期');
                }
            },
            // 点击阅卷
            openScoring(item){
                let examType = item.examType
                if(examType == '复核'){
                    let routeData = this.$router.resolve({name: "reCheckScoring", query: {e: item.id, }});
                    window.open(routeData.href, '_blank');
                }else{
                    let routeData = this.$router.resolve({name: "scoring", query: {e: item.id, }});
                    window.open(routeData.href, '_blank');
                }

            },
            // 跳转到检测页面
            jumpCheck(item){
                let examId = item.id
                let url = '#/scoringCheck?examId=' + examId
                window.open(url, '_blank')
            },

        }
    }

</script>

<style lang="scss" scoped type="text/scss" rel="stylesheet/scss">
    .dataDashBoard {

        .row_list {
            .row_base {
                padding: 10px;
                box-sizing: border-box;
                background: #fff;
                border-radius: 6px;
                height: 120px;
            }
        }
        .content-row{
        }
        .col-span{
            font-size: 18px;
            color: #4D4D4D;
        }

    }

    
    .box-card {
        margin: 15px;
    }
</style>